module.exports = __webpack_public_path__ + "img/particle_motion_00064.f54bc2a0.png";